export enum ContractPaymentErrorOrigin {
    CREATE_CONTRACT_PAYMENT = 'CREATE_CONTRACT_PAYMENT',
    GET_CASHBOX_STMT_RECORDS = 'GET_CASHBOX_STMT_RECORDS',
    GET_CONTRACT_PAYMENTS = 'GET_CONTRACT_PAYMENTS',
    SEND_CONTRACT_PAYMENT_RECEIPT = 'SEND_CONTRACT_PAYMENT_RECEIPT',
}

export interface ContractPaymentError {
    type: ContractPaymentErrorOrigin,
    detail: any
}